import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Provider, EnvironmentProviders, InjectionToken, inject, provideAppInitializer } from '@angular/core';

import { keycloakProviders } from 'projects/admin/src/app/auth/keycloak/keycloak-providers';
import { AdminAuthorizationInterceptor } from 'projects/admin/src/app/interceptor/admin-authorization.interceptor';
import { AdminInternalAuthService } from 'projects/admin/src/app/service/admin-internal-auth.service';
import { Auth } from 'shared/constants/auth.enum';
import { ExpirationCookieName } from 'shared/openapi/models/expiration-cookie-name';
import { AuthBaseService } from 'shared/services/auth-base.service';

export const AUTH_CONFIG: InjectionToken<Auth> = new InjectionToken('AUTH_CONFIG');

function sessionRefreshInitializer(authService: AuthBaseService) {
	return () => authService.init(ExpirationCookieName.AdminCookieExpiration);
}

const internalAuthProviders: Array<Provider | EnvironmentProviders> = [
	{
		provide: AuthBaseService,
		useClass: AdminInternalAuthService,
	},
	{
		provide: HTTP_INTERCEPTORS,
		useClass: AdminAuthorizationInterceptor,
		multi: true,
		deps: [AuthBaseService],
	},
	provideAppInitializer(() => {
		const initializerFn = sessionRefreshInitializer(inject(AuthBaseService));
		return initializerFn();
	}),
];

export function getAuthProviders(auth: string): Array<Provider | EnvironmentProviders> {
	if (auth === Auth.INTERNAL) {
		return internalAuthProviders;
	} else if (auth === Auth.KEYCLOAK) {
		return keycloakProviders;
	} else {
		throw new Error('One of the supported auth types have to be chosen.');
	}
}
